import { MutationTree } from 'vuex'
import * as types from './mutation-types'
import TransportState from '../types/TransportState'

const mutations: MutationTree<TransportState> = {
  [types.SET_TRANSPORT]  (state, payload: any[]) {
    state.transport = payload
  }
}

export default mutations
